import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

/*
https://stackoverflow.com/questions/47968529/how-do-i-use-jquery-and-jquery-ui-with-parcel-bundler
*/